<script setup>
/**
 * @todo When the legacy theme is removed: delete the legacyProps prop, the useTheme import,
 * and remove legacyProps from the effectiveProps spread.
 */

import { computed, useAttrs } from 'vue';

import { useTheme } from '../composables/useTheme';

/**
 * Loading spinner with circular (default) and dots style variants.
 *
 * @status internal
 * @group status-feedback
 * @see https://quasar.dev/vue-components/spinners Quasar q-spinner API
 */
defineOptions({ name: 'HrSpinner' });

const props = defineProps({
  /**
   * Spinner animation style.
   * @values default, dots
   */
  type: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'dots'].includes(v),
  },
  /** Spinner diameter as a CSS length string (e.g. '32px'). Defaults to the theme standard when not set. */
  size: {
    type: String,
    default: undefined,
  },
  /**
   * Legacy props forwarded to the underlying Quasar component.
   * @deprecated Only for backwards compatibility with the legacy theme — ignored when a design system theme is active.
   */
  legacyProps: {
    type: Object,
    default: () => ({}),
  },
});

const attrs = useAttrs();
const { hasTheme } = useTheme();

const effectiveProps = computed(() => ({
  size: props.size,
  ...(hasTheme.value ? {} : props.legacyProps),
  ...attrs,
}));
</script>

<template>
  <component
    :is="props.type === 'dots' ? 'q-spinner-dots' : 'q-spinner'"
    v-bind="effectiveProps"
  />
</template>
